import { z } from 'zod';
import { addressValidationSchema } from './shared/address';
export const claimSchema = z.object({
    interChangeControlId: z.string(),
    payerName: z.string().min(1, 'insurance name required'),
    payerId: z.string().min(1, 'insurance is required'),
    receiverId: z.string().min(1, 'insurance receiver id required'),
    submitterId: z.string().min(1, 'organization submitter id required'),
    sentDate: z.string().date(),
    sentTime: z.string(),
    submissionType: z.enum(['P', 'T']),
    claimTypes: z.array(z.object({
        groupControlId: z.string(),
        agencies: z.array(z.object({
            transactionControlId: z.string(),
            taxId: z.string().min(1, 'agency tax id required'),
            name: z.string().min(1, 'agency name required'),
            contactName: z.string().min(1, 'agency contact required'),
            contactNumber: z.string().min(1, 'agency contact number required'),
            npi: z.string().min(1, 'agency npi required'),
            address: addressValidationSchema,
            claims: z.array(z.object({
                patient: z.object({
                    claimControlNumber: z.string(),
                    episodeClaimId: z.string(),
                    insuranceId: z.string(),
                    insuranceRelationship: z.string(),
                    admitType: z.string(),
                    admitSource: z.string(),
                    admitStatus: z.string(),
                    firstName: z.string(),
                    lastName: z.string(),
                    dob: z.string(),
                    gender: z.string(),
                    address: addressValidationSchema,
                    primaryDiagnosis: z.object({
                        code: z.string(),
                    }),
                    otherDiagnoses: z.array(z.object({
                        code: z.string(),
                    })),
                    provider: z.object({
                        firstName: z.string(),
                        lastName: z.string(),
                        npi: z.string(),
                    }),
                }),
                claimType: z.string(),
                admissionDate: z.string(),
                startDate: z.string(),
                endDate: z.string(),
                occurrences: z
                    .array(z
                    .object({
                    code: z.string(),
                    startDate: z.string().date(),
                    endDate: z.string().date(),
                })
                    .optional())
                    .optional(),
                valueCodes: z
                    .array(z
                    .object({
                    code: z.string(),
                    value: z.string(),
                })
                    .optional())
                    .optional(),
                services: z.array(z.object({
                    claimVisitId: z.string(),
                    revenueCode: z.string(),
                    serviceCode: z.string(),
                    visitType: z.string(),
                    date: z.string().date(),
                    amount: z.string(),
                    units: z.string(),
                })),
            })),
        })),
    })),
});
